import React from "react";
import { useField } from "formik";

import SelectDataReferencia from "./SelectDataReferencia";

function FormikSelectDataReferencia(props) {
  const [field, meta] = useField({ name: "dataRef", ...props });

  return <SelectDataReferencia {...field} {...meta} {...props} />;
}

export default FormikSelectDataReferencia;
